import { render } from "./ImportInstanceDialog.vue?vue&type=template&id=2cbc0928"
import script from "./ImportInstanceDialog.vue?vue&type=script&lang=js"
export * from "./ImportInstanceDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__